import $ from 'jquery';
import { apiHost } from '@square/environment-utils/api-urls';
import { connectHost } from '@square/environment-utils/connect-urls';
export function isSquareUrl(url) {
  const anchor = document.createElement('a');
  anchor.href = url;
  const validHostnames = ['localhost', 'squareup.com', 'squareupsandbox.com', 'squareupstaging.com', 'app.squareup.com', 'app.squareupsandbox.com', 'app.squareupstaging.com'];
  return validHostnames.includes(anchor.hostname);
}
export function urlMatchesCurrentHost(url) {
  const anchor = document.createElement('a');
  anchor.href = url;
  return anchor.hostname === location.hostname;
}

/**
 * @param {string} service service name, e.g. squareup.multipass.external.MultipassExternalService
 * @param {string} method method name, e.g. ListTwoFactor
 * @param {boolean} usesApiHost whether the service lives at api.squareup.com or squareup.com
 * @returns {string}
 */
export function serviceRpcUrl(service, method, usesApiHost = false) {
  return baseRpcUrl(`/services/${service}/${method}`, usesApiHost);
}

/**
 * @param {string} path endpoint path, e.g. /mp/status
 * @param {boolean} usesApiHost whether the service lives at api.squareup.com or squareup.com
 * @returns {string}
 */
export function baseRpcUrl(path, usesApiHost = false) {
  const host = usesApiHost ? apiHost(location.host) : location.host;
  if (host === location.host) {
    return path;
  } else {
    return `//${host}${path}`;
  }
}
export function baseConnectUrl(path, useSameHost = false) {
  return `//${connectHost(location.host, {
    useSameHost
  })}${path}`;
}
// eslint-disable-line @typescript-eslint/no-explicit-any
/*
 * @param {string} url
 * @param {object} params
 * @returns {string}
 */
export function constructUrl(url, params) {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${$.param(params)}`; // eslint-disable-line ember/no-jquery
}